import React from 'react';
const Navigation = () => {
  return null; // Sidebar removed per user request
};
export default Navigation;
